<template>
  <div class="title">
    {{ title }}
    <span class="tip">
      {{ tip }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['title', 'tip'],
}
</script>

<style scoped>
.title {
  color: #1a1a1aff;
  font-size: 16px;
  height: 52px;
  line-height: 52px;
  font-weight: 400;
  padding-left: 24px;
  border-bottom: 1px solid #e4e4e4;
}
.tip {
  font-size: 12px;
  color: #ea8f4d;
  font-weight: normal;
}
</style>
